var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircle = function SvgCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 2.102c5.465 0 9.896 4.431 9.896 9.896s-4.43 9.895-9.895 9.896c-5.466 0-9.897-4.431-9.897-9.896s4.431-9.896 9.897-9.896m0 .968a8.928 8.928 0 1 0 0 17.856A8.928 8.928 0 0 0 12 3.07"
  })));
};
export default SvgCircle;